export default {
  hero: {
    title: "Basetao Spreadsheet — La guía completa de productos, vendedores y recursos",
    subtitle:
      "Encuentra, compara y comprende los recursos de Basetao Spreadsheet en un solo lugar. Explora guías prácticas, información de vendedores, investigación de productos, costos de envío, detalles del almacén, cupones, reseñas, consejos de QC y orientación de seguridad.",
    trust: "Recurso independiente · Guías prácticas · Actualizado regularmente",
    dropdownLabel: "Explorar una categoría",
    dropdownPlaceholder: "Elige una categoría…",
  },
  whatIs: {
    title: "¿Qué es Basetao Spreadsheet?",
    p1: "Un Basetao Spreadsheet es una base de datos de productos organizada que ayuda a los compradores a encontrar y comparar artículos disponibles a través del agente de compras Basetao. En lugar de desplazarte por miles de anuncios individuales, puedes explorar un único documento estructurado que agrupa los productos por categoría e incluye detalles útiles como información del vendedor, referencias de productos y notas prácticas.",
    p2: "Piénsalo como un mapa: no vende nada por sí mismo, pero te ayuda a entender qué productos existen, cómo se agrupan y dónde buscar a continuación. El spreadsheet está organizado en torno a categorías de compra comunes — zapatos, sudaderas, camisetas, chaquetas, bolsos, cinturones y más — para que puedas acotar rápidamente tu búsqueda al tipo de producto que realmente quieres.",
  },
  article: {
    title: "Guías y recursos",
    subtitle: "Lee guías claras y originales para sacar el máximo partido al Basetao Spreadsheet.",
    cardTitle: "¿Qué es Basetao Spreadsheet? Guía para principiantes",
    cardDesc:
      "Una visión completa y amigable: qué es el spreadsheet, qué contiene, cómo usarlo y qué revisar antes de hacer un pedido.",
    readMore: "Leer la guía",
    viewAll: "Ver todas las guías",
    related: "Artículos relacionados",
    updated: "Actualizado regularmente",
  },
  faq: {
    title: "Preguntas frecuentes",
    q1: "¿Qué es Basetao Spreadsheet?",
    a1: "Es una lista organizada por categorías de productos y referencias que ayuda a los compradores a investigar artículos disponibles a través del agente de compras Basetao.",
    q2: "¿Cómo uso Basetao Spreadsheet?",
    a2: "Abre el spreadsheet, elige una categoría, anota las referencias de productos que quieres, compara los detalles de los vendedores y verifica los precios y la disponibilidad actuales en la plataforma oficial antes de hacer el pedido.",
    q3: "¿Basetao es legítimo?",
    a3: "Basetao es un agente de compras conocido, pero como con cualquier agente, siempre debes verificar tú mismo los vendedores, productos, precios y políticas antes de tomar una decisión de compra.",
    q4: "¿Cuánto cuesta el envío de Basetao?",
    a4: "Los costos de envío dependen del peso, el volumen, el destino y el método de envío que elijas. Las tarifas cambian con el tiempo, así que revisa siempre las condiciones actuales antes de pedir.",
    q5: "¿Basetao tiene cupones o códigos de descuento?",
    a5: "Las ofertas pueden aparecer de vez en cuando, pero la disponibilidad y los requisitos pueden cambiar. Verifica siempre que un código siga siendo válido antes de depender de él.",
  },
  ctaSection: {
    title: "¿Listo para explorar el spreadsheet completo?",
    subtitle:
      "Explora el catálogo completo, compara categorías y comienza a investigar productos en el sitio principal.",
    button: "Visitar el sitio principal",
  },
};